export default __webpack_public_path__ + "static/media/reno.e5aac0e7.jpeg";